import React from 'react';

function BrowerNotSupport() {
  return <div>Chrome으로 해주세요..</div>;
}

export default BrowerNotSupport;
